//@flow

import React from "react"
import { Switch, Route } from "react-router-dom"
import values from "lodash.values"
import { Cubic, Back, TweenMax } from "gsap"
import SVGLoader from "../../UI/SVGLoader"
import IntroView from "./Intro"
import BikeView from "./Bike"
import WalkView from "./Walk"
import RideView, { WaitingToRideScene } from "./Ride"
import IdlingView from "./Idling"
import CarpoolView from "./Carpool"
import SweepView from "./Sweep"
import FuelView from "./Fuel"

import {
  Container,
  Toolbar,
  ToolbarItem,
  ToolbarButton,
  ContentWindow
} from "./UI"

import iconRide from "../Icons/iconCommitRide.svg"
import iconFuel from "../Icons/iconCommitFuel.svg"
import iconBike from "../Icons/iconCommitBike.svg"
import iconWalk from "../Icons/iconCommitWalk.svg"
import iconIdling from "../Icons/iconCommitIdling.svg"
import iconCarpool from "../Icons/iconCommitCarpool.svg"
import iconSweep from "../Icons/iconCommitSweep.svg"

import type { RouterHistory } from "react-router-dom"

type Props = {
  history: RouterHistory
}

class CommitView extends React.Component<Props> {
  navItems: { [string]: ?HTMLElement }

  constructor(props: Props) {
    super(props)
    this.navItems = {
      bike: null,
      ride: null,
      walk: null,
      sleep: null,
      idling: null,
      carpool: null,
      fuel: null
    }
  }

  componentDidMount() {
    const items = values(this.navItems).filter(el => el !== null)
    TweenMax.set(items, { y: 240, opacity: 0 })
    TweenMax.staggerTo(
      items,
      0.25,
      { opacity: 1, ease: Cubic.easeOut, delay: 0.5 },
      0.15
    )
    TweenMax.staggerTo(
      items.filter(el => el !== null),
      0.65,
      { y: 0, ease: Back.easeOut, delay: 0.5 },
      0.15
    )
  }

  selectAction = (action: string) => {
    const { history: { push } } = this.props
    push(`/kiosk/section/commit/${action}`)

    const deselectables = Object.keys(this.navItems)
      .filter(key => key !== action)
      .map(key => this.navItems[key])
      .filter(el => el !== null)

    TweenMax.to(deselectables, 0.5, {
      rotation: 0,
      y: 0,
      ease: Back.easeOut
    })
    TweenMax.set(this.navItems[action], {
      scale: 1.25,
      y: -30
    })
    TweenMax.to(this.navItems[action], 1.5, {
      rotation: -5,
      y: -10,
      opacity: 1,
      scale: 1,
      ease: Back.easeOut
    })
  }

  render() {
    return (
      <Container>
        <ContentWindow>
          <Switch>
            <Route path="/kiosk/section/commit/bike" component={BikeView} />
            <Route path="/kiosk/section/commit/ride" component={RideView} />
            <Route path="/kiosk/section/commit/walk" component={WalkView} />
            <Route path="/kiosk/section/commit/sweep" component={SweepView} />
            <Route path="/kiosk/section/commit/idling" component={IdlingView} />
            <Route
              path="/kiosk/section/commit/carpool"
              component={CarpoolView}
            />
            <Route path="/kiosk/section/commit/fuel" component={FuelView} />
            <Route component={IntroView} />
          </Switch>
        </ContentWindow>
        <Toolbar>
          <ToolbarItem>
            <ToolbarButton
              innerRef={el => (this.navItems.bike = el)}
              onClick={() => this.selectAction("bike")}
            >
              <SVGLoader path={iconBike} height="100%" width="100%" />
            </ToolbarButton>
          </ToolbarItem>
          <ToolbarItem>
            <ToolbarButton
              innerRef={el => (this.navItems.ride = el)}
              onClick={() => this.selectAction("ride")}
            >
              <SVGLoader path={iconRide} height="100%" width="100%" />
            </ToolbarButton>
          </ToolbarItem>
          <ToolbarItem>
            <ToolbarButton
              innerRef={el => (this.navItems.carpool = el)}
              onClick={() => this.selectAction("carpool")}
            >
              <SVGLoader path={iconCarpool} height="100%" width="100%" />
            </ToolbarButton>
          </ToolbarItem>
          <ToolbarItem>
            <ToolbarButton
              innerRef={el => (this.navItems.walk = el)}
              onClick={() => this.selectAction("walk")}
            >
              <SVGLoader path={iconWalk} height="100%" width="100%" />
            </ToolbarButton>
          </ToolbarItem>
          <ToolbarItem>
            <ToolbarButton
              innerRef={el => (this.navItems.idling = el)}
              onClick={() => this.selectAction("idling")}
            >
              <SVGLoader path={iconIdling} height="100%" width="100%" />
            </ToolbarButton>
          </ToolbarItem>
          <ToolbarItem>
            <ToolbarButton
              innerRef={el => (this.navItems.fuel = el)}
              onClick={() => this.selectAction("fuel")}
            >
              <SVGLoader path={iconFuel} height="100%" width="100%" />
            </ToolbarButton>
          </ToolbarItem>
          <ToolbarItem>
            <ToolbarButton
              innerRef={el => (this.navItems.sweep = el)}
              onClick={() => this.selectAction("sweep")}
            >
              <SVGLoader path={iconSweep} height="100%" width="100%" />
            </ToolbarButton>
          </ToolbarItem>
        </Toolbar>
      </Container>
    )
  }
}

export { WaitingToRideScene }
export default CommitView



// WEBPACK FOOTER //
// ./src/Kiosk/CommitView/index.js